import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const CheckIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
    </SvgIcon>
  );
};

CheckIcon.propTypes = {}

CheckIcon.defaultProps = {}

export default CheckIcon;